import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Mail, Phone, MapPin } from 'lucide-react';
import { navigation } from '../data/mock';

const Footer = () => {
  return (
    <footer className="bg-navy text-cream relative overflow-hidden" role="contentinfo">
      <div className="absolute inset-0 grain pointer-events-none" />
      {/* CTA strip */}
      <div className="border-b border-cream/10">
        <div className="max-w-[1440px] mx-auto px-6 lg:px-12 py-16 lg:py-20">
          <div className="grid lg:grid-cols-12 gap-10 items-end">
            <div className="lg:col-span-8">
              <p className="eyebrow text-bronze mb-6">ממשיכים מכאן</p>
              <h2 className="display-2 text-cream">
                בואו להבין איפה השיווק שלכם<br />
                <span className="text-bronze">יכול לעבוד טוב יותר.</span>
              </h2>
            </div>
            <div className="lg:col-span-4 lg:text-left">
              <Link
                to="/contact"
                className="btn-cta inline-flex items-center gap-3 bg-cream text-navy px-7 py-4 text-base tracking-wide hover:bg-bronze transition-colors duration-300"
              >
                קבעו שיחת אבחון
                <ArrowLeft className="arrow w-5 h-5" />
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Footer columns */}
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12 py-16">
        <div className="grid grid-cols-2 lg:grid-cols-12 gap-10">
          <div className="col-span-2 lg:col-span-5">
            <h3 className="font-serif text-2xl tracking-tight mb-4">
              Gal<span className="text-bronze" aria-hidden="true">&</span>Blizovsky
            </h3>
            <p className="text-cream/70 text-sm leading-relaxed max-w-md">
              חברת אסטרטגיה וצמיחה שבונה ומנהלת מערכי שיווק ודיגיטל
              מקצה לקצה — תחת אסטרטגיה אחת, מדידה ומנוהלת.
            </p>
          </div>

          <div className="col-span-1 lg:col-span-3">
            <p className="eyebrow text-bronze mb-4">ניווט</p>
            <nav aria-label="ניווט תחתית">
              <ul className="space-y-3">
                {navigation.map((item) => (
                  <li key={item.path}>
                    <Link
                      to={item.path}
                      className="text-cream/70 hover:text-bronze text-sm transition-colors duration-300"
                    >
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>
          </div>

          <div className="col-span-1 lg:col-span-4">
            <p className="eyebrow text-bronze mb-4">יצירת קשר</p>
            <address className="not-italic">
              <ul className="space-y-4">
                <li className="flex items-start gap-3 text-cream/70 text-sm">
                  <Mail className="w-4 h-4 mt-0.5 text-bronze flex-shrink-0" aria-hidden="true" />
                  <a href="mailto:office@gal-bl.co.il" className="hover:text-bronze transition-colors">
                    office@gal-bl.co.il
                  </a>
                </li>
                <li className="flex items-start gap-3 text-cream/70 text-sm">
                  <Phone className="w-4 h-4 mt-0.5 text-bronze flex-shrink-0" aria-hidden="true" />
                  <a href="tel:+972528812428" className="hover:text-bronze transition-colors">
                    052-881-2428
                  </a>
                </li>
                <li className="flex items-start gap-3 text-cream/70 text-sm">
                  <MapPin className="w-4 h-4 mt-0.5 text-bronze flex-shrink-0" aria-hidden="true" />
                  <span>נתניה, ישראל · קצרין, ישראל</span>
                </li>
              </ul>
            </address>
          </div>
        </div>

        <div className="border-t border-cream/10 mt-14 pt-8 flex flex-col lg:flex-row justify-between gap-4 text-sm text-cream/50">
          <p>© {new Date().getFullYear()} Gal&Blizovsky. כל הזכויות שמורות.</p>
          <div className="flex gap-6">
            <Link to="/contact" className="hover:text-bronze transition-colors">צור קשר</Link>
            <span>מדיניות פרטיות</span>
            <span>תנאי שימוש</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
